export default __webpack_public_path__ + "static/media/GvLogoBlack.2bc95b5f.svg";